import React, {useState, useEffect} from "react"

import FormattedMessage from "@irati/utils/lang"
import mainTheme from "@irati/ui/src/global/theme"
import Button from "@irati/ui/src/Button"
import Close from "@irati/ui/src/Close"

import RenewalHeader, {AddOns} from "../../Renewal/Header"
import {CustomModal, CustomCard} from "./styled"

interface Props {
  show: boolean
  addOns: AddOns[]
  onHide: () => void
}

const FinalCancellationModal: React.FC<Props> = ({show, addOns, onHide}) => {
  const [showModal, setShowModal] = useState<boolean>(show)

  useEffect(() => {
    setShowModal(show)
  }, [show])

  return (
    <CustomModal show={showModal} onHide={onHide}>
      <CustomCard bgColor={mainTheme.colors.primary2} marginBottom={4} padding={5}>
        <Close top={mainTheme.spacing.two} right={mainTheme.spacing.two} color={mainTheme.colors.greys.white} onClick={onHide} />
        <RenewalHeader
          title="admin.billing.currentPlan.finalCancellationModal.header"
          body="admin.billing.currentPlan.finalCancellationModal.body"
          pending="admin.billing.currentPlan.finalCancellationModal.pending"
          showPending
          addOns={addOns}
        />
      </CustomCard>

      <Button marginLeft={5} marginBottom={3} primary onClick={onHide}>
        <FormattedMessage id="admin.billing.currentPlan.finalCancellationModal.btn" />
      </Button>
    </CustomModal>
  )
}

export default FinalCancellationModal
